module.exports = __webpack_public_path__ + "img/pie.e6c6c804.png";